<template>
  <section class="px-6">
    <v-container v-if="_isXAdmin(userProfile)">
      <v-row justify="end">
        <v-toolbar flat color="transparent">
          <v-row justify="space-between">
            <v-col cols="12" md="4" lg="4" class="d-flex flex-row">
              <v-select
                v-if="xprofessions"
                v-model="selectedProfession"
                :items="xprofessions"
                label="Мэргэжил"
                return-object
                item-text="name2"
                item-value="id"
              >
              </v-select>

              <v-btn
                v-if="selectedProfession != null"
                color="blue"
                class="pa-0 ml-4"
                dark
                elevation="0"
                text
                @click="selectedProfession = null"
                >Clear</v-btn
              >
            </v-col>
            <v-row align="center" justify="end">
              <v-col cols="12" md="6" lg="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Xайx"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-row>
        </v-toolbar>
      </v-row>
    </v-container>
    <material-card
      icon="mdi-clipboard-text"
      icon-small
      color="accent"
      v-if="items && items.length > 0 && loading == false"
    >
      <!-- <v-btn @click="_changeAll">change All</v-btn> -->
      <v-row justify="end" class="mx-4">
        <v-col>
          <h3>{{ numberOfselectedItems }}</h3>
        </v-col>
        <v-col cols="auto">
          <v-checkbox label="Төгссөн" v-model="isStudied"></v-checkbox>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            label="Тодорxойгүй"
            v-model="isStudyingUndefined"
          ></v-checkbox>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            label="Суралцаж байгаа оюутнууд"
            v-model="isStudying"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="selectedItems"
        :search="search"
        :items-per-page="-1"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.index }}</td>
            <td>{{ props.item.studentCode }}</td>
            <td>{{ props.item.firstName }}</td>
            <td>{{ props.item.lastName }}</td>
            <td>{{ props.item.phone }}</td>
            <td style="background: #fff9c4">{{ props.item.currentGPA }}</td>
            <!-- <td class="font-weight-bold">
              <span v-if="props.item.classGroupProgram">{{
                props.item.classGroupProgram.name2
              }}</span>
              <span v-else>-</span>
            </td> -->

            <td class="font-weight-bold">
              <span v-if="props.item['xClassGroupProgram-2022-2023-1']"
                >{{ props.item["xClassGroupProgram-2022-2023-1"].name2 }}
              </span>
              <span v-else>-</span>
            </td>
            <!-- <td class="font-weight-bold red--text">
              <span v-if="props.item['xClassGroupRef-' + _getPostFix()]">{{
                props.item["xClassGroupRef-" + _getPostFix()].id
              }}</span>
              <span v-else>-</span>
            </td> -->
            <td v-if="props.item.state">
              <small v-if="props.item.state.code == 1" style="color: green">{{
                props.item.state.name
              }}</small>
              <small v-else style="color: red">{{
                props.item.state.name
              }}</small>
            </td>
            <td v-else>-</td>
            <td>
              <template>
                <v-btn
                  small
                  elevation="0"
                  class="mr-2 red lighten-4 red--text"
                  @click.stop="_detail(props.item, props.item.index)"
                  v-if="_isXAdmin(userProfile) || userProfile.role=='accountant'"
                >
                  Төлбөр
                </v-btn>
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </material-card>
    <v-card v-if="loading" height="200">
      <v-progress-linear
        height="25"
        indeterminate
        color="red"
      ></v-progress-linear>
    </v-card>
    <div class="py-3" />

    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.firstName }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.firstName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.lastName }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.phone }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.email }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="inputScoreDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline"> Дүн оруулаx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  autofocus
                  type="Number"
                  v-model.number="editedItem.currentGPA"
                  label="Score"
                />
              </v-col>

              <!-- <v-col cols="12">
                <v-select
                  v-model="editedItem.semester"
                  :items="xsemesters"
                  return-object
                  item-text="name"
                  item-value="id"
                  label="Semester"
                >
                </v-select>
              </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn
            color="secondary"
            class="text-capitalize font-weight-bold"
            @click="saveScore"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("@/firebaseConfig.js");
import myfunction from "@/components/utils/myfunction.js";
export default {
  data: () => ({
    xsemesters: null,
    inputScoreDialog: false,
    isStudyingUndefined: true,
    isStudying: true,
    isStudied: false,
    selectedClassGroup: null,
    selectedClassGroupProgram: null,
    xBeingStates: null,
    loading: false,
    search: "",
    selectedProfession: null,
    detailDialog: false,
    newDialog: false,
    newBulkDialog: false,
    deleteDialog: false,
    editedItem: {
      firstName: "",
    },
    editedIndex: -1,
    defaultItem: {
      firstName: "",
    },
    items: [],

    messageNotification: null,

    bulkText: null,
    bulkXprofession: null,
    bulkYear: null,
    xprofessions: null,
    vselect_professions: [],
    xClassGroups: null,
    tmpItems: [],
  }),
  mixins: [myfunction],
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Код",
          align: "start",
          sortable: true,
          value: "studentCode",
        },
        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "firstName",
        },
        {
          text: "Овог",
          align: "start",
          sortable: true,
          value: "lastName",
        },
        {
          text: "Утас",
          align: "start",
          sortable: true,
          value: "phone",
        },
        {
          text: "GPA",
          align: "start",
          sortable: true,
          value: "currentGPA",
        },
        {
          text: "Мэргэжил/Анги",
          align: "start",
          sortable: true,
          value: "classGroupName",
        },
        {
          text: "Төлөв",
          align: "start",
          sortable: true,
          value: "state.name2",
        },
      ];
    },
    numberOfselectedItems: function () {
      if (this.selectedItems) return this.selectedItems.length;
      else return null;
    },
    selectedItems: function () {
      var list = [];
      if (this.items != null) {
        var counter = 0;
        if (this.selectedProfession != null) {
          if (this.selectedProfession.all) {
            for (var item of this.items) {
              counter++;
              item.index = counter;
              //this._setXClass(item);
              if (
                this.isStudying &&
                item.state &&
                item.state.id != "HwCdcfzoY7vc6EUOtREf"
              )
                list.push(item);
            }
          } else {
            for (var item of this.items) {
              counter++;
              item.index = counter;
              if (
                item["xClassGroupRef-" + this._getPostFix()] &&
                item["xClassGroupRef-" + this._getPostFix()].id ===
                  this.selectedProfession.id
              ) {
                //this._setXClass(item);
                if (
                  this.isStudying &&
                  item.state &&
                  item.state.id != "HwCdcfzoY7vc6EUOtREf"
                )
                  list.push(item);
              }
            }
          }
        } else {
          for (var item of this.items) {
            //this._setXClass(item);
            if (this.isStudying) {
              if (item.state && item.state.id != "HwCdcfzoY7vc6EUOtREf") {
                counter++;
                item.index = counter;
                list.push(item);
              }
            }
            if (this.isStudyingUndefined && this.isStudying == false) {
              if (item.state == undefined) {
                counter++;
                item.index = counter;
                list.push(item);
              }
            }
            if (this.isStudied) {
              if (item.state && item.state.name == "Төгссөн") {
                counter++;
                item.index = counter;
                list.push(item);
              }
            }
            if (
              !this.isStudying &&
              !this.isStudyingUndefined &&
              !this.isStudied
            ) {
              counter++;
              item.index = counter;
              list.push(item);
            }
          }
        }
      }
      return list;
    },
  },
  created() {
    this._setupp();
    this._read();
  },

  methods: {
    _getPostFix() {
      return "2022-2023-1";
    },
    _changeAll() {
      this.items.forEach((student) => {
        this._changeState(student);
      });
    },
    _changeState(item) {
      console.log(item["xClassGroupRef-" + this._getPostFix()].path);
    },
    _setXClass(student) {
      if (student.xprofession) {
        if (student.classNumber) {
          student.xClass =
            student.xprofession.shortName + "-" + student.classNumber;
        } else student.xClass = student.xprofession.shortName + "-x";
      }
    },
    _increaseClasses() {
      var counter = 0;
      for (var student of this.items) {
        counter++;
        if (student["classIncreased-2021"] == true) {
        } else {
          console.log(counter, student.ref.path);
        }
      }
    },
    _clearBulkText() {
      this.bulkText = null;
      this.tmpItems = [];
    },

    _detail(item, index) {
      this.editedItem = item;
      //this.detailDialog = true;
      console.log(item.ref.path);
      this.$router.push({
        name: "StudentDetail",
        params: { studentPath: item.ref.path, collectionpath: "payments" },
      });
    },

    _editItemForScore(item, index) {
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
      this.inputScoreDialog = true;
    },

    _addScores(item, index) {
      this.editedItem = item;
      //this.detailDialog = true;
      console.log(item.ref.path);
      this.$router.push({
        name: "AdminStudentScores",
        params: { studentPath: item.ref.path },
      });
    },

    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      this.inputScoreDialog = false;
      this.tmpItems = [];

      this.bulkText = null;
      this.bulkXprofession = null;
      this.bulkYear = null;
      this.messageNotification = null;

      this.selectedClassGroup = null;
      this.selectedClassGroupProgram = null;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    saveScore() {
      this.editedItem.ref
        .update({
          currentGPA: this.editedItem.currentGPA,
          currentGPADate: new Date(),
        })
        .then(() => {
          this.newDialog = false;
          this.newBulkDialog = false;
          this.inputScoreDialog = false;
        });
    },
    _setupp() {
      console.log(this.school);
      this.school.ref
        .collection("/xprofessions")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xprofessions = [{ name2: "Бүгд", all: true }];
          this.vselect_professions = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.name2 = "(" + item.shortName + ") " + item.name;
            this.xprofessions.push(item);
            this.vselect_professions.push(item);
          });
        });


      // this.school.ref
      //   .collection("xschoolyears")
      //   .orderBy("createdAt", "asc")
      //   .onSnapshot((querySnapshot) => {
      //     this.xsemesters = [];
      //     querySnapshot.forEach((doc) => {
      //       let item = doc.data();
      //       item.id = doc.id;
      //       item.ref = doc.ref;
      //       item.ref
      //         .collection("semesters")
      //         .get()
      //         .then((xdocs) => {
      //           this.xsemesters = [];
      //           xdocs.forEach((xdoc) => {
      //             let sem = xdoc.data();
      //             sem.id = xdoc.id;
      //             sem.ref = xdoc.ref;
      //             sem.name2 =
      //               sem.startYear + "-" + sem.endYear + "-" + sem.code;
      //             sem.name =
      //               sem.startYear + "-" + sem.endYear + ", " + sem.shortName;
      //             this.xsemesters.push(sem);
      //           });
      //         });
      //     });
      //   });
      // this.school.ref
      //   .collection("/xBeingStates")
      //   .orderBy("name", "asc")
      //   .onSnapshot((querySnapshot) => {
      //     this.xBeingStates = [];
      //     this.vselect_professions = [];
      //     querySnapshot.forEach((doc) => {
      //       let item = doc.data();
      //       item.id = doc.id;
      //       item.ref = doc.ref;
      //       this.xBeingStates.push(item);
      //     });
      //   });
      // this.school.ref
      //   .collection("/classGroups/2022-2023/classGroups")
      //   .orderBy("name", "asc")
      //   .onSnapshot((querySnapshot) => {
      //     this.xClassGroups = [];
      //     querySnapshot.forEach((doc) => {
      //       let item = doc.data();
      //       item.id = doc.id;
      //       item.ref = doc.ref;
      //       item.programs = null;
      //       item.name2 =
      //         item.name +
      //         " (" +
      //         item.shortName +
      //         ")" +
      //         " /" +
      //         item.degreeName +
      //         "/";
      //       item.ref.collection("programs").onSnapshot((docs) => {
      //         item.programs = [];
      //         docs.forEach((doc) => {
      //           var program = doc.data();
      //           program.ref = doc.ref;
      //           program.id = doc.id;
      //           program.name2 = program.shortName + "-" + program.classNumber;
      //           item.programs.push(program);
      //         });
      //       });

      //       this.xClassGroups.push(item);
      //     });
      //   });
    },
    _read() {
      this.loading = true;
      this.school.ref
        .collection("students")
        .orderBy("firstName", "asc")
        .onSnapshot((querySnapshot) => {
          this.items = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            // console.log(
            //   item,
            //   item["xClassGroupProgram-" + this._getPostFix()].name2,
            //   "xClassGroupProgram-" + this._getPostFix()
            // );
            if (
              item["xClassGroupProgram-" + this._getPostFix()] &&
              item["xClassGroupProgram-" + this._getPostFix()].name2
            ) {
              item.classGroupName =
                item["xClassGroupProgram-" + this._getPostFix()].name2;
            } else item.classGroupName = null;
            // if (item.professionRef == undefined) {
            //   if (item.xprofession) {
            //     item.professionRef = item.xprofession.ref;
            //     item.xprofession.id = item.xprofession.ref.id;
            //     //item.ref.update(item);
            //   }
            // }
            this.items.push(item);
          });
          this.loading = false;
        });
    },
  },
};
</script>
